import Util from './util.js'

function _calculateProperties() {
	this.height = $(this.$el).parent().height()
	this.offsetTop = $(this.$el).parent().offset().top
}

function _calculateProgress(event) {
	this.scrollingProgress = this.height - this.$root.$store.state.scroll + $(this.$el).parent().offset().top
	this.progress = this.scrollingProgress / this.height
}

function _checkBelowViewport() {
	if (this.scrollingProgress <= 1) {
		this.belowViewport = false
		this.progress = 0
	} else {
		this.belowViewport = true
	}
}

function _scrollHandler(event) {

	this.calculateProperties()
	this.calculateProgress(event)
	this.checkBelowViewport()

	// Check if stuck
	this.progress < 1 && this.progress > 0 ? this.stuck = true : this.stuck = false

}

function _addToHistory() {
	window.history.pushState({}, null, this.slug)
	this.inHistory = true
}

function _removeFromHistory() {
	window.history.back()
	this.inHistory = false
}

function _scrollToTop() {
	Util.scrollToPosition(this.offsetTop);
}

Vue.directive('visible', (el, binding) => {
    let value = binding.value
    if (!!value) {
        el.style.visibility = 'visible'
    } else {
        el.style.visibility = 'hidden'
    }
});

let StickyHeader = Vue.component('sticky-header', {
	props: ['title', 'color', 'slug', 'cursor'],
	methods: {
		checkBelowViewport: _checkBelowViewport,
		scrollToTop: _scrollToTop,
		addToHistory: _addToHistory,
		removeFromHistory: _removeFromHistory,
		calculateProperties: _calculateProperties,
		calculateProgress: _calculateProgress,
		scrollHandler: _scrollHandler
	},
	mounted() {
		window.stickyfill.add(this.$el)
		this.$nextTick(function() {
			Util.eventBus.$on('doScrollEvents', this.scrollHandler)
			this.calculateProperties()
			this.calculateProgress()
		})
	},
	computed: {
		cursorClass: function() {
			if (this.cursor == 'circle') return 'circle'
			return 'internal'
		},
		stuckClass: function() {
			if (this.stuck) return 'stuck'
		},
		scrollingStyle: function() {
			if (this.$root.$store.state.isScrolling) {
				return {
					position: 'relative',
					top: this.stuck ? $(this.$el).position().top + 'px' : '0px'
				}
			} else {
				return {
					position: ['sticky', '-webkit-sticky'],
					top: 0
				}
			}
		}
	},
	data() {
		return {
			aboveViewport: false,
			scrollingProgress: 0,
			scrollTop: 0,
			progress: 0,
			height: 0,
			offsetTop: 0,
			stuck: false,
			inHistory: false
		}
	},
	template: `
	<div class="section-header-container" :class="stuckClass" :style="scrollingStyle">
		<header :style="{ color: color }" :class="cursorClass" class="section-header">
	  		<h1 v-visible="!this.stuck" v-html="title"></h1>
	  		<h1 v-visible="this.stuck" v-html="title" class="h1-sticky"></h1>
		</header>
		<div class="header-bg"></div>
	</div>`
})

export default StickyHeader
